import { useRef, useEffect } from 'react'
import { SearchIcon } from 'lucide-react'
import { isMac } from '../../utils/tools'
import { Input } from '../ui'

const SearchInput = ({ value, onChange, placeholder, allowHotkey = true }) => {
    const searchInputRef = useRef(null)

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (!allowHotkey) return

            // Check for Cmd+K (Mac) or Ctrl+K (Windows/Linux)
            if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
                e.preventDefault() // Prevent default browser behavior
                searchInputRef.current?.focus()
            }
        }

        document.addEventListener('keydown', handleKeyDown)
        return () => document.removeEventListener('keydown', handleKeyDown)
    }, [])

    return (
        <div className="tw:relative tw:flex-1">
            <span className="tw:absolute tw:left-3 tw:top-1/2 tw:-translate-y-[54%] tw:right-3 tw:px-1.5 tw:py-0.5 tw:rounded tw:text-xs tw:text-gray-600 tw:pointer-events-none tw:pl-0">
                <SearchIcon size={16} className="tw:text-gray-200" />
            </span>
            <Input
                ref={searchInputRef}
                name="search"
                type="text"
                value={value}
                onChange={({ target }) => onChange(target.value)}
                placeholder={placeholder || 'Search by file name'}
                className="tw:placeholder:!text-gray-200 tw:pl-9 tw:pr-20"
            />
            {allowHotkey && (
                <span className="shortcut-hint tw:absolute tw:right-3 tw:top-1/2 tw:-translate-y-1/2 tw:bg-[#21262d] tw:px-1.5 tw:py-0.5 tw:rounded tw:text-xs tw:text-[#8b949e] tw:border tw:border-[#30363d] tw:pointer-events-none">
                    {isMac ? '⌘' : 'Ctrl'} + K
                </span>
            )}
        </div>
    )
}

export default SearchInput
